import script from "./SolicitacoesRepository.vue?vue&type=script&lang=js"
export * from "./SolicitacoesRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__